import ReportTable from './report-table'
import ReportTableHandler from '../../handlers/report-table'

const builtReportTables = []

function teardownReportTables() {
  builtReportTables.forEach((reportTable) => {
    reportTable.teardown()
  })
  builtReportTables.length = 0
}

function initReportTables() {
  document
    .querySelectorAll('table[data-behaviour="report-table"]')
    .forEach(function (el) {
      builtReportTables.push(new ReportTable(el))
    })

  const handler = new ReportTableHandler($(document))
  handler.restoreReportSettings()
}

function onTurbolinksLoad() {
  const renderedTable = document.querySelector(
    "table[data-behaviour='report-table']"
  )
  if (renderedTable) {
    initReportTables()
  }
}

function onFrameLoad(event) {
  if (event.target?.id !== 'report-table') return
  teardownReportTables()
  initReportTables()
}

document.addEventListener('turbolinks:load', onTurbolinksLoad)
document.addEventListener('turbolinks:before-visit', teardownReportTables)
document.addEventListener('turbo:frame-load', onFrameLoad)
